//--- React Libraries
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
//---Project 
import { getEOLGraphData, getEolGraphLiveData } from "apis/eolApis";
import NoData from "components/Common/NoData";
import Loading from "components/Common/Loading";
import APIError from "components/Common/APIError";
import TimeSeriesChart from "components/Common/TimeSeriesChart";

const HBEolGraphPanel = ({plotColor, panelSeries, panelField, panelTable, panelUnits='', showLive=false}) => {
  const eol = useSelector((state) => state.eol);
  const vehicleDetails = eol?.vehicleDetails;
  const imei = vehicleDetails?.vehImei;

  const selectedHBTestId = eol?.selectedHBTestId;

  const liveGraphQuery = {
    queryKey: ['hblivegraphs', imei, panelField],
    keepPreviousData: true,
    queryFn: () => getEolGraphLiveData(imei, panelField, panelTable),
    enabled: !!(imei && panelField && panelTable),
    staleTime: 1 * 10 * 60 * 1000, // it is 10m 
    refetchInterval: 5 * 1000
  }

  const graphQuery = {
    queryKey: ['hbeolgraphs', imei, selectedHBTestId, panelField ],
    keepPreviousData: true,
    queryFn: () => getEOLGraphData(imei, selectedHBTestId, panelField, panelTable),
    enabled: !!(imei && selectedHBTestId && panelField && panelTable),
    staleTime: 1 * 10 * 60 * 1000, // it is 10m 
  }

  const {data: hbEolGraphData, 
    isLoading: hbEolGraphLoading, 
    isError: hbEolGraphIsError,
    error: hbEolGraphError,} = useQuery(showLive ? liveGraphQuery : graphQuery);


  const formatGraphData = (fieldName) => {
    const timeSeriesData = hbEolGraphData?.data.map((dataItem) => {
        return [dataItem.timestamp, dataItem[fieldName]]
    });
    return timeSeriesData;
  }

  return(
    <>
    {hbEolGraphLoading && <Loading/>}
    {hbEolGraphIsError && <APIError message={hbEolGraphError.message}/>}
    {!hbEolGraphLoading && !hbEolGraphData?.data && <NoData/>}
    {!hbEolGraphIsError && hbEolGraphData?.data && 
        <TimeSeriesChart
          seriesColor={plotColor}
          seriesName={panelSeries}
          yAxisUnits={panelUnits}
          data={formatGraphData(panelField)}
        />
    }
    </>
  )
}

export default HBEolGraphPanel;